var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment1Black(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M542.5,1040c-75,0-140-25-195-80c-55-55-80-120-80-195V240c0-55,20-100,60-140s85-60,140-60s100,20,140,60 c40,40,60,85,60,140v475c0,35-10,65-35,90s-55,35-90,35s-65-10-90-35s-35-55-35-90V280c0-10,5-20,10-25s15-10,25-10s20,5,25,10 c5,5,10,15,10,25v440c0,15,5,25,15,35c10,10,20,15,35,15c15,0,25-5,35-15c10-10,15-20,15-35V240c0-35-10-65-35-90s-55-35-90-35 s-60,15-85,35s-35,55-35,90v525c0,55,20,100,60,140c40,40,85,60,140,60s100-20,140-60c40-40,60-85,60-140V280c0-10,5-20,10-25 c5-5,15-10,25-10c10,0,20,5,25,10s10,15,10,25v490c0,75-25,140-80,195C682.5,1015,617.5,1040,542.5,1040z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment1Black);
export default __webpack_public_path__ + "static/media/attachment-1-black.22d7dba8654f211293d007ce098c4c4c.svg";
export { ForwardRef as ReactComponent };